'use client'

import dynamic from 'next/dynamic'

const EyesWebGL = dynamic(() => import('@/components/common/EyesWebGL'), {
  ssr: false,
})

export default function EyesWrapper() {
  return (
    <div className="w-full h-full overflow-hidden">
      <EyesWebGL />
    </div>
  )
}
